/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-plusplus */
/* eslint-disable import/order */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import _ from '@lodash';
import 'ag-grid-enterprise';
import { useEffect, useState, useRef } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useToast from '@fuse/hooks/useToast'
import { useDispatch } from 'react-redux'
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations';
import RestoreArchiveModal from 'app/fuse-layouts/shared-components/modal/RestoreArchiveModal';

function ListView(props) {
	const table_name = "ARCHIVED_ASSETS";
	const transform_words = {
		id: 'ID',
		sku: 'SKU',
		eol: 'EOL',
		eosl: 'EOSL',
		no: 'No.'
	};

	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');
	const [tabState, setTabState] = useState("information");
	const router = useRouter()
	const dispatch = useDispatch();
	const toast = useToast(dispatch)
	const [gridApi, setGridApi] = useState(null);
	const [headers, setHeaders] = useState([])
	const gridRef = useRef();
	const [isGridReady, setIsGridReady] = useState(0)
	const skipHeader = [
		'id', 'model_id', 'shipping_location_details', 'status_value', 'contract_header', 'contract_tag_color',
		'assigned_user_details', 'source', 'portal', 'asset_type',
		'purchase_price', 'purchase_date', 'install_date', 'order_number', 'contract_no',
		'sku', 'make', 'city', 'eol', 'eosl', 'service_id', 'warranty_end_date',
		'name', 'sub_category', 'original_info', 'image_name', 'contract_status_value', 'location_obj'
	]
	const [displayButton, setDisplayButton] = useState(false);
	const [statusMenu, setStatusMenu] = useState([])
	const [assetId, setAssetId] = useState(null)
	const [assetDetail, setAssetDetails] = useState(null);
	const [isLocationModal, setIsLocationModal] = useState(false)

	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs, setLogs] = useState([]);
	const [filterApplied, setFilterApplied] = useState(false);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const [restoreData, setRestoreData] = useState();
	const [isConfirmModal, setIsConfirmModal] = useState(false);

	const generateHeaderLabel = (header) => {
		if (header === 'serial_no') {
			return 'Serial Number'
		}
		if (header === 'model') {
			return 'Model Name'
		}
		if (header === "location_name") {
			return "Location";
		}

		if (header === 'detailed_description_of_the_issue') {
			return 'Issue Description'
		}

		if (header === "user_name") {
			return "User";
		}

		if (header === "mac_id") {
			return "Mac Address";
		}

		return header.split('_').map(word => {
			if (word in transform_words) return transform_words[word];
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	const handleClickOpen = (asset_id) => {
		router.push(`/archived-assets/${asset_id}`)
	};

	const handleRestore = () => {
		if (assetDetail !== null) {
			axios.delete(`assets/restore-asset/${assetDetail.id}`, {
				data: { ...restoreData },
			}).then((res) => {
				if (res.status === 201) {
					toast.error(res.data.message)
				} else {
					props.fetchAssets()
					toast.success(res.data.message)
					setIsConfirmModal(false)
					setRestoreData(null)
					setAssetDetails(null)
				}
			}).catch(err => {
				console.log('err', err);
				toast.error(err.response.data.message)
			})
		}
	}

	const handleConfirmRestore = (assetData) => {
		setAssetDetails(assetData)
		setIsLocationModal(true)
	}

	const handleCloseRestore = () => {
		// setAssetDetails(null)
		setIsLocationModal(false);
	}

	const onGridReady = (params) => {
		// gridRef.current = params
		setIsGridReady(isGridReady + 1)
		setGridApi(params);
		setHeaders(Object.keys(props.endUsersAccounts[0]))
		// props.endUsersAccounts.forEach((list) => {
		// 	for(let [fieldName, value] of Object.entries(list)){
		// 		if(value === '-') list[fieldName] = `No ${formatString(fieldName)}`
		// 	}
		// })
		if (router.query.report_name === undefined) {
			loadInitialState(params)
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		} else {
			setRowGroupPanelShow('always')
		}
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name === undefined) {
				saveView(rows);
			}
		}
	}

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length !== 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex !== endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)

		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}
	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);
		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== 'ag-Grid-AutoColumn') {
				dispatch(setrowGroupModel([]));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
	}

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		// const order = JSON.stringify(rows);
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then(results => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (filter?.length > 0 && Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch(err => {
				console.log(err);
			})
	}

	// useEffect(()=>{
	// 	gridRef?.current?.api?.setQuickFilter(
	// 		query_data
	// 	  );
	// },[query_data])

	// useEffect(() => {
	// 	return () => {
	// 			dispatch(setQuickFilter(null))
	// 	}
	// }, [])

	const onFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit(4500);
	};

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	useEffect(() => {
		if (!router.params?.serial_no) return
		handleClickOpen(router.params.serial_no)
	}, [])

	function handleHideColumnDropDownDesign() {
		if (!groupByArr.length) {
			return {
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "space-between",
				border: "1px solid #000000",
				borderRadius: "20px",
				padding: "3px 10px",
				backgroundColor: "#ffffff",
				lineHeight: "1",
				height: "28px",
				position: "relative",
				cursor: "pointer",
				fontFamily: '"Inter", sans-serif',
				fontSize: "13px",
				fontWeight: 500,
			};
		}
		return {}
	}

	return (
		<>
			<AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="Archived Asset"
				displayTableName="Archived Assets"
				key={isGridReady}
			/>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 165,
					fontSize: '12px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme="legacy"
					headerClass="ag-right-aligned-header"
					onFirstDataRendered={onFirstDataRendered}
					onGridReady={onGridReady}
					animateRows
					rowData={props.endUsersAccounts ?? undefined}
					rowHeight={35}
					headerHeight={44}
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					// autoGroupColumnDef={{ minWidth: 500 }}
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					cacheQuickFilter

					pagination

					components={frameworkComponents}

					defaultColDef={{
						// flex: 1,
						// minWidth: 180,
						enableRowGroup: true,
						sortable: true,
						resizable: true
					}}
					columnDefs={[
						{
							lockPosition: true,
							rowSelection: "single",
							width: 100,
							minWidth: 100,
							maxWidth: 100,
							suppressSizeToFit: true,
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							pinned: 'right',
							className: "action_field",
							lockPinned: true,
							cellRenderer: ({ data }) => {
								if (data) {
									return (
										<>
											{(props.viewAssetPermission.length > 0 || props.viewAssetPermission === 'all' ||
												(props.viewAssetPermission.map(i => i === data.location_obj.id).length > 0)
											) &&
												<Tooltip id="view" title="View" placement="top">
													{/* <Icon onClick={()=>handleClickOpen(data.id)} fontSize='small' style={{color: '#1d2939',paddingBottom: '3px',paddingRight:'30px',fontSize:'15px',cursor:'pointer'}} >visibility</Icon> */}
													<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-eye" onClick={() => handleClickOpen(data.id)} />
												</Tooltip>
											}

											{(props.createAssetPermission.length > 0 || props.createAssetPermission === 'all' ||
												(props.createAssetPermission.map(i => i === data.location_obj.id).length > 0)
											) && <Tooltip id="restore" title="Restore" placement="top">
													{/* <Icon onClick={() => handleRestore(data.id)} style={{color: '#1d2939',paddingBottom: '3px',paddingRight:'30px',fontSize:'15px',cursor:'pointer'}}>unarchive_outlined</Icon> */}
													<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-reload" onClick={() => handleConfirmRestore(data)} />
												</Tooltip>}
										</>
									)
								}
								return (<></>)

							}
						},
						...Object.keys(props.endUsersAccounts[0])?.filter((item) => !skipHeader.includes(item))?.map(header => {
							const baseCol = {
								field: header,
								key: header,
								flex: 1,
								minWidth: 200,
								headerName: generateHeaderLabel(header),
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef))
							}
							if (header === 'serial_no') {
								return {
									...baseCol,
									suppressSizeToFit: true,
									suppressRowClickSelection: true,
								}
							} if (header === "contract_tag") {
								return {
									...baseCol,
									suppressSizeToFit: true,
								}
							}
							if (
								header === "created_date" ||
								header === "updated_date"
							) {
								return {
									...baseCol,
									cellRenderer: (event) => {
										return (
											<span>{dateReformatTo_mmm_dd_yyyy(event.value)}</span>
										)
									}
								}
							}
							if (header === 'asset_tag') {
								return {
									...baseCol,
									suppressSizeToFit: true,
								}
							}
							if (header === 'serial_no') {
								return {
									...baseCol,
									suppressSizeToFit: true,
								}
							}
							if (header !== 'location_obj') {
								if (header === 'status') {
									return {
										...baseCol,
										suppressSizeToFit: true,
										cellRenderer: (event) => {
											if (event.colDef.field === "status") {
												return (
													<span style={handleHideColumnDropDownDesign()}>
														<span style={{
															height: '10px',
															width: '10px',
															marginTop: '2px',
															borderRadius: '50%',
															display: 'inline-block',
															backgroundColor: event.data?.status_value?.status_color?.code
														}} />
														<span style={{ marginLeft: '5px' }}>{event.data?.status_value?.status_name}</span>
													</span>
												)
											} if (event.colDef.headerName === 'Group' && event.node.field === 'status') {
												return <><span>{event.value}</span></>
											}
											return (<><span>{event.value}</span></>)

										}
									}
								}
								if (header === 'location') {
									return {
										...baseCol,
										suppressSizeToFit: true,
									}
								}
								if (header === 'user_name') {
									return {
										...baseCol,
										suppressSizeToFit: true,
									}
								}
								if (header === 'name') {
									return {
										...baseCol,
										suppressSizeToFit: true,
									}
								}
								if (header === 'notes') {
									return {
										...baseCol,
										suppressSizeToFit: true,
									}
								}

								return {
									...baseCol,
									suppressSizeToFit: true,
								}

							}
							if (header === 'purchase_price') {
								return {
									...baseCol,
									suppressSizeToFit: true,
								}
							}
							return <></>;
						})]}
				/>
			</div>
			{isLocationModal && (
				<RestoreArchiveModal openAddStatusModalStateData={isLocationModal} handleOpenCloseAddModalEvent={handleCloseRestore} handleSave={(data) => {
					setRestoreData({ ...data, })
					setIsConfirmModal(true)
				}} />
			)}
			{isConfirmModal && (
				<GeneralModal
					open={isConfirmModal}
					title="Are you sure to restore asset?"
					text={<h4>Are you sure to restore this Contract named as <b>{assetDetail?.asset_name}</b>?</h4>}
					handleClose={() => {
						setIsConfirmModal(false)
						setAssetDetails(null)
						setRestoreData(null)
					}}
					detailMessage="The asset will be restored with updated status and location based on user selection"
					handleConfirm={handleRestore}
					actionButtonName="Yes, Procced!"
				/>
			)}
		</>
	);
}

export default ListView